<p [class.muted]="item.changeStatus === 'DECLINED_WITH_REASON'">
  <ion-text [color]="item.isChangeOrder ? 'gc-blue' : 'gc-green'"
  ><strong data-cy="change-order-pending-items" class="pending">{{ item | numberOfUnitsStillPending }} PENDING</strong></ion-text
  >
</p>
